import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getServicePaymentAndSteps = (serviceId) => {
  return http.get(
    `${getBaseUrl()}/service_payment_and_step/${serviceId}`
  );
};
export const getServicedSteps = (serviceId) => {
  return http.get(
    `${getBaseUrl()}/service_step/${serviceId}`
  );
};

export const submitAgentServiceSideCost = data => {
  return http.post(
    `${getBaseUrl()}/service_agent_side_cost`,
    data
  );
};

export const updateAgentServiceSideCost = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/service_agent_side_cost/${data.id}`,
    data
  );
};